<template>
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <a-form :form="form" slot="detail">
          <a-row>
            <a-col :span="24" v-show="type!='chargeUser'&&type!='spendUser'">
              <a-form-item label="班级" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <j-select-depart
                  @change="getDepartStudent"
                  :onlyLeaf="true"
                  :onlyCategory="3"
                  :rootOpened="true"
                  :multi="false"
                  v-decorator="['departId', validatorRules.departId]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="24" v-show="type!='chargeUser'&&type!='spendUser'">
              <a-form-item label="学生" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <!-- <j-select-user-by-dep v-decorator="['userId', validatorRules.userId]" /> -->
                <a-select v-decorator="['userId', validatorRules.userId]" defaultValue="">
                  <a-select-option key="all" value="" >全部</a-select-option>
                  <a-select-option v-for="user in userList" :key="user.id" :value="user.id">{{user.username}}</a-select-option>
                </a-select>
                <a-tag color="red"> 不选择学生，将默认选择班级下的所有学生 </a-tag>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="type != 'detail'">
              <a-form-item
                :label="type.includes('charge') ? '充值课时' : '消耗课时'"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
              >
                <a-input-number
                  v-decorator="['courseHour', validatorRules.totalHour]"
                  placeholder="请输入课时"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
  
            <a-col :span="24" v-if="type == 'detail'">
              <a-form-item label="总 课时" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number
                  v-decorator="['totalHour', validatorRules.totalHour]"
                  placeholder="请输入总课时"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="type == 'detail'">
              <a-form-item label="已消耗课时" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number v-decorator="['spendHour']" placeholder="请输入消耗课时" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
              <a-button @click="submitForm">提 交</a-button>
            </a-col>
          </a-row>
        </a-form>
      </j-form-container>
    </a-spin>
  </template>
  
  <script>
  import { postAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
  
  export default {
    name: 'TeachingUserCourseHourForm',
    components: {
      JFormContainer,
      JSelectDepart,
      JSelectUserByDep,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: () => {},
        required: false,
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false,
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false,
      },
      //操作类型 chargeUser chargeDepart spendUser spendDepart detail
      type: {
        type: String,
        default: 'detail',
        required: true,
      },
    },
    data() {
      return {
        form: this.$form.createForm(this),
        model: {},
        userList: [],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          userId: {},
          departId: {
            rules: [{ required: true, message: '请选择一个班级!' }],
          },
          courseHour: {
            rules: [{ required: true, message: '请输入课时!' }],
          },
        },
        url: {
          add: '/teaching/teachingUserCourseHour/add',
          edit: '/teaching/teachingUserCourseHour/edit',
          queryById: '/teaching/teachingUserCourseHour/queryById',
          charge: '/teaching/teachingUserCourseHour/chargeCourseHour',
          spend: '/teaching/teachingUserCourseHour/spendCourseHour',
        },
      }
    },
    computed: {
      formDisabled() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return true
          }
        }
        return false
      },
    },
    created() {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData()
    },
    methods: {
      add() {
        this.edit({})
      },
      edit(record) {
        this.form.resetFields()
        this.model = Object.assign({}, record)
        this.visible = true
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'userId', 'departId', 'totalHour', 'spendHour'))
        })
      },
      //渲染流程表单数据
      showFlowData() {
        if (this.formBpm === true) {
          let params = { id: this.formData.dataId }
          getAction(this.url.queryById, params).then((res) => {
            if (res.success) {
              this.edit(res.result)
            }
          })
        }
      },
      getDepartStudent(depIds) {
        var params = {}
        params.depId = depIds
        params.pageSize = 999;
        getAction('/sys/user/departUserList', params).then((res) => {
          if (res.success && res.result) {
            this.userList = res.result.records
          }
        })
      },
      submitForm() {
        const that = this
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true
            let httpurl = ''
            if (this.type.includes('charge')) {
              httpurl = this.url.charge
            } else if (this.type.includes('spend')) {
              httpurl = this.url.spend
            } else {
              return
            }
  
            let formData = Object.assign(this.model, values)
            console.log('表单提交数据', formData)
            getAction(httpurl, formData)
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'userId', 'departId', 'totalHour', 'spendHour'))
      },
    },
  }
  </script>